import { CboRole } from '@cbo/shared-library';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import { Redirect } from 'react-router-dom';
import PlaceholderPage from '../../../pages/PlaceholderPage';
import routes from '../../constants/routes';
import { useUsers } from '../../contexts/userContext';
import DashboardPage from '../DashboardPage/DashboardPage';

function HomePage() {
  const user = useUsers();

  const loadingComponent = (
    <Grid container alignItems='center' justifyContent='center' data-testid='spinner-container'>
      <CircularProgress />
    </Grid>
  );

  if (user.fullyAuthenticated === 'authenticated') {
    if (user.bslAuth?.roles.includes(CboRole.ADMIN_DASHBOARD_VIEWER)) {
      return <DashboardPage />;
    }

    return <Redirect to={routes.MY_SCHEDULE} />;
  }

  if (user.oktaStatus === 'unauthenticated') {
    return <PlaceholderPage contentText='Welcome to NCR Voyix Aloha Smart Manager' dataTestId='temp-landing-page' />;
  }

  return loadingComponent;
}

export default HomePage;
